import { render, staticRenderFns } from "./invitation.vue?vue&type=template&id=b5e43d7a&scoped=true"
import script from "./invitation.vue?vue&type=script&lang=js"
export * from "./invitation.vue?vue&type=script&lang=js"
import style0 from "./invitation.vue?vue&type=style&index=0&id=b5e43d7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e43d7a",
  null
  
)

export default component.exports